<template>
    <div>
        <div>
            <Row type="flex">
                <i-col v-for="(item,index) in skuList" :key="index">
                    <div :style="{width:getMaxWidth(index),height:'120px',textAlign:'right',backgroundColor: 'white'}">
                        <div class="tag_class">
                            <span class="price_class">到手价:  {{getStatus(item)}} 元</span>
                        </div>
                        <img :src="item.imageInfo.imageList[0].url" :width="getMaxWidth(index)"/>
                    </div>
                </i-col>
            </Row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "JdSelectSku",
        data() {
            return {
                screenWidth: 0,
                skuList: [],
            }
        },
        created() {
            this.getWidth();
            this.getTopList();
        },
        mounted() {
            const that = this;
            window.onresize = () => {
                return (() => {
                    that.getWidth();
                })()
            }
        },
        computed: {
            getStatus() {
                return function (item) {
                    return this.getPrice(item);
                }
            },
            getMaxWidth(){
                return function (num) {
                    if(num===0 || num===5 || num===10){
                        return this.screenWidth
                    }else{
                        return this.screenWidth/2
                    }
                }
            }
        },
        methods: {
            getPrice(item) {
                let price = item.priceInfo.lowestPrice;
                let couponList = item.couponInfo.couponList;
                let coupon = null;
                if (couponList.length > 0) {
                    for (let i = 0; i < couponList.length; i++) {
                        let _coupon = couponList[i];
                        let _isBest = _coupon.isBest;
                        if (_isBest === 1) {
                            coupon = _coupon;
                        }
                    }
                }
                if (coupon) {
                    let discount = coupon.discount;
                    price = price - discount;
                }
                if(price.toString().indexOf('.')>-1){
                    return  price.toFixed(2)
                }else {
                    return price.toFixed(0)
                }
            },
            getWidth() {
                window.screenWidth = document.body.clientWidth;
                this.screenWidth = window.screenWidth;
                this.$log(this.screenWidth);
            },
            getTopList() {
                let start_day = '2019-09-16';
                let end_day = '2019-09-16';
                let that = this;
                this.$getTopList(start_day, end_day, function (response) {
                    this.$log(response);
                    if (response.data) {
                        that.skuList = response.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .tag_class {
        text-align: right;
        position: absolute;
        /*z-index: 999;*/
        background-color: #D70C12;
        color: white;
        right: 0px;
        bottom: 5px;
        padding: 3px;
        background-color:rgba(215,12,18,0.7);
    }

    .price_class {
        /*position: absolute;*/
        font-size: 15px;
        bottom: 0px;
    }
</style>